import { parseReportDateForSort } from "./reportDateSortUtils";
import { getNextSortConfig } from "./dailySaleReportTableConfig";

export { getNextSortConfig };

export const CUSTOM_ORDER_REPORT_COLUMN_FIELDS = [
  null,
  "date",
  "order_no",
  "SKU",
  "stock_id",
  "metal_name",
  "stone_name",
  "size_name",
  "qty",
  "base_amount",
  "labour",
  "amount",
  "payment",
  "outstanding",
  "delivery_date",
  "location_name",
  "customer_name",
  "sales_person",
  "cart_status",
  null,
];

const NUMERIC_FIELDS = new Set([
  "qty",
  "base_amount",
  "labour",
  "amount",
  "payment",
  "outstanding",
]);

const DATE_FIELDS = new Set(["date", "delivery_date"]);

const getSortValue = (row, field) => {
  if (field === "cart_status") {
    const value = row?.status?.cart_status;
    if (value === null || value === undefined || value === "") return null;
    const num = Number(value);
    return Number.isFinite(num) ? num : null;
  }

  const value = row?.[field];
  if (value === null || value === undefined || value === "") return null;
  if (DATE_FIELDS.has(field)) return parseReportDateForSort(value);
  if (NUMERIC_FIELDS.has(field)) {
    const num = Number(value);
    return Number.isFinite(num) ? num : null;
  }
  return String(value).toLowerCase();
};

const compareValues = (left, right) => {
  if (left === null && right === null) return 0;
  if (left === null) return 1;
  if (right === null) return -1;
  if (typeof left === "number" && typeof right === "number") {
    return left - right;
  }
  return String(left).localeCompare(String(right), undefined, {
    sensitivity: "base",
    numeric: true,
  });
};

export const sortCustomOrderReportRows = (rows, sortConfig) => {
  if (!Array.isArray(rows) || !rows.length) return rows || [];
  if (!sortConfig?.columnIndex || sortConfig.columnIndex === 0) return rows;

  const field = CUSTOM_ORDER_REPORT_COLUMN_FIELDS[sortConfig.columnIndex];
  if (!field) return rows;

  const direction = sortConfig.direction === "desc" ? -1 : 1;

  return [...rows].sort((rowA, rowB) => {
    const comparison = compareValues(
      getSortValue(rowA, field),
      getSortValue(rowB, field)
    );
    return comparison * direction;
  });
};
